import React, { useContext, useState } from 'react';
import { useTheme, Button, CheckBox, Overlay } from '@rneui/themed';
import { Text, View } from 'react-native';
import PropTypes from 'prop-types';
import GivingContext, { ActionTypes } from '../../../contexts/Giving';
import { useDeviceInfo } from '../../../hooks';

// TODO: Refactor into a single select child which is
//       parameterized instead of using one for recurring and another for once.

const GiveOverlayModal = props => {
    const { state, dispatch } = useContext(GivingContext);
    const { isMobile } = useDeviceInfo();
    const [selectedRecurrence, setSelectedRecurrence] = useState();
    const { theme } = useTheme();
    const question2Text = props.json?.question2Text;

    const SelectGiftOptions = () => {
        return state?.funds?.map((item, idx) => {
            // Needs work to show selections of only the items that are not in the parent state
            return (
                <CheckBox
                    key={item.fundCode}
                    title={item.name}
                    containerStyle={{
                        backgroundColor: idx === state?.modal?.selection ? theme?.colors?.lightgrey : theme?.colors?.white,
                        borderWidth: 0,
                        borderRadius: 6
                    }}
                    textStyle={{
                        color: theme?.colors?.verydarkgrey,
                        fontFamily: 'GothamMedium',
                        fontSize: !isMobile ? '12pt' : 12,
                        textAlign: 'left'
                    }}
                    checkedIcon={false}
                    uncheckedIcon={false}
                    checked={idx === state?.modal?.selection}
                    onPress={() => {
                        dispatch({
                            type: ActionTypes.SELECT_GIFT,
                            data: idx
                        });
                    }}
                />
            );
        });
    };

    const SelectRecurringOptions = () => {
        return (
            <>
                <Text
                    style={{
                        fontSize: isMobile ? 16 : '16pt',
                        fontFamily: 'GothamMedium',
                        marginBottom: 10,
                        color: theme?.colors?.verydarkgrey
                    }}
                >
                    {question2Text}
                </Text>
                {state?.recurrences?.map(option => (
                    <CheckBox
                        key={option.type}
                        containerStyle={{
                            backgroundColor: selectedRecurrence === option.type ? theme?.colors?.verydarkgrey : theme?.colors?.white
                        }}
                        title={new String(option.name.split(/(?=[A-Z])/).join(' '))}
                        textStyle={{
                            textAlign: 'left',
                            fontFamily: 'GothamMedium',
                            fontSize: !isMobile ? '12pt' : 12,
                            color: selectedRecurrence === option.type ? theme?.colors?.white : theme?.colors?.verydarkgrey
                        }}
                        checkedIcon={false}
                        uncheckedIcon={false}
                        checked={selectedRecurrence === option.type}
                        onPress={e => setSelectedRecurrence(option.type)}
                    />
                ))}
                <View
                    style={{
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }}
                >
                    <Button
                        title='CONFIRM'
                        titleStyle={{
                            fontFamily: 'GothamMedium',
                            fontSize: !isMobile ? '12pt' : 12,
                            color: theme?.colors?.verydarkgrey
                        }}
                        color={theme?.colors?.transparent}
                        onPress={() => {
                            dispatch({
                                type: ActionTypes.SELECT_RECURRENCE,
                                data: selectedRecurrence
                            });
                        }}
                    />
                    <Button
                        title='CANCEL'
                        titleStyle={{
                            fontFamily: 'GothamMedium',
                            fontSize: !isMobile ? '12pt' : 12,
                            color: theme?.colors?.verydarkgrey
                        }}
                        color={theme?.colors?.transparent}
                        onPress={() => {
                            dispatch({
                                type: ActionTypes.HIDE_MODAL
                            });
                        }}
                    />
                </View>
            </>
        );
    };

    return (
        <Overlay
            isVisible={state?.modal?.visible}
            onBackdropPress={() => {
                dispatch({
                    type: ActionTypes.HIDE_MODAL
                });
            }}
            overlayStyle={{
                borderColor: theme?.colors?.verydarkgrey,
                borderWidth: 0.5,
                borderRadius: 6,
                shadowColor: '#171717',
                shadowOffset: { width: -3, height: 3 },
                shadowOpacity: 0.2,
                shadowRadius: 3,
                margin: theme?.margins?.gutter,
                width: isMobile ? '85%' : '50%'
            }}
            supportedOrientations={['portrait', 'landscape']}
        >
            {!state?.modal.isRecurrence && <SelectGiftOptions />}
            {state?.modal.isRecurrence && <SelectRecurringOptions />}
        </Overlay>
    );
};

GiveOverlayModal.propTypes = {
    question2Text: PropTypes.string
};

export default GiveOverlayModal;
